/**
 * 交付範圍 —— 哪些模組已經可以給客戶看。
 *
 * ## 規則（2026-09-15 裁示，寫進 CLAUDE.md 硬規則）
 *
 * **串接完 API 的畫面就不該再藏。** 一個模組只要後端 controller 已經接上（真的打得到、
 * 不是 mock、不是空殼），就把它在下表打開；還沒有後端、只跑 mock 或只有空殼的，留在外面。
 * 這張表不是「這個月排到哪」的進度表，是「客戶現在點得到什麼」的事實表。
 *
 * ## 為什麼要有這張表，而不是把路由直接刪掉
 *
 * 側欄的模組可見性來自後端 `AdminMenu/GetMenu`（ADR-0003），前端擋不住它給什麼。
 * 2026-09-08 到 09-15 之間出過一次事故：旗標把 `postAugust` 的**路由**整批拿掉，
 * 但側欄改吃後端選單之後不再吃這個旗標 —— 結果側欄看得到「營運資訊／監控派工／審核中心」，
 * 點進去卻是「找不到這個頁面」（票 36 的 e2e 實測抓到）。
 *
 * 所以 **`allRoutes` 與 `SidebarContent` 一定要吃同一張表**：表上沒有的模組，
 * 側欄不畫、路由也不掛，兩邊不會再各說各話。
 *
 * ## 與 DevNote 的差別
 *
 * `DevNote`（`components/DCKeeper/DevNote`）是「這塊**根本還沒做**，只給開發看」；
 * 這張表是「這個模組**做好了也接上後端了沒有**」。兩件事，不要混用。
 */

/**
 * 模組 → 客戶看不看得到。
 * 加一列之前先問：它的後端 controller 真的接上了嗎？（`docs/api-串接現況.md` 是事實來源）
 */
export const RELEASED_MODULES = {
  // 營運資訊（9 月交付）：IP 已接 DcIpAddress（票 16）、合約讀取側已接 DcContract（票 33）。
  // 專案／廠商的 DcProject／DcVendor 仍 404，頁面還吃 mock —— 但同屬 9 月交付範圍，
  // 依 9/15 裁示一起開；後端到位前客戶看到的是示範資料（待確認清單 一、17）。
  registry: true,

  // 監控（選購包）：DcMonitor／DcDispatch 不在 swagger 裡，整頁是示意。
  monitor: false,

  // 審核中心（10 月執行）：審核引擎還是前端 mock，後端沒有對應 controller。
  approvals: false,

  // 報表（11 月）與決策分析（選購包）：空殼頁。
  report: false,
  decision: false,
};

/**
 * 這個模組現在給不給客戶看。
 *
 * 表上沒有的鍵一律當「沒開放」,但要**吵一聲**(CLAUDE.md:降級不准安靜失效)——
 * 打錯一個字(`registory`)會把整批路由默默抽掉,正是票 36 的故障形態。
 */
export const isModuleReleased = (moduleKey) => {
  if (!(moduleKey in RELEASED_MODULES)) {
    console.warn(`[releaseScope] 不認得的模組鍵「${moduleKey}」,當成未開放處理 —— 打錯字了嗎?`);
    return false;
  }
  return RELEASED_MODULES[moduleKey] === true;
};
